import Start_Main_SignIn_MainSection from "./Start_Main_SignIn_MainSection";
import Start_Main_SignIn_NoAccount from "./Start_Main_SignIn_NoAccount";
import { Outlet } from "react-router-dom";
import React from "react";

class Start_Main_SignIn extends React.Component {
    render() {
        return(
            <div className="start_main_signIn">
                <h2 className="start_main_signIn_heading">Sign in to dZen</h2>
                <Start_Main_SignIn_MainSection />
                <Start_Main_SignIn_NoAccount />
                <Outlet />
            </div>
        )
    }
}

export default Start_Main_SignIn;